<template>
    <v-app id="inspire" class="payout-details-wrap">
        <!-- Header -->
        <div class="details-header">
            <v-layout class="wrap">
                <span class="headline">Payout ID: {{payout.id}}</span>
                <v-spacer></v-spacer>
                <v-btn class="header-btn-back mr-0 mb-3 mt-0" @click="$router.go(-1)">
                    <v-icon class="header-btn-back-icon">navigate_before</v-icon>
                    Back
                </v-btn>
            </v-layout>
        </div>
        <div class="details-header">
            <v-layout class="wrap">
                <v-flex v-if="!loading">
                    <v-layout class="align-center justify-start mb-2 text-body-2"><div>Date Created: <strong v-if="!no_data.includes(payout.date)">{{payout.date}}</strong><em v-else class="grey--text">No data</em></div></v-layout>
                    <v-layout class="align-center justify-start mb-6 text-body-2"><div>Arrival date: <strong v-if="!no_data.includes(payout.arrival_date)">{{payout.arrival_date}}</strong><em v-else class="grey--text">No data</em></div></v-layout>
                </v-flex>
            </v-layout>
            <!-- Header boxes -->
            <v-container v-if="!loading" class="grid-list-lg pa-0 container--fluid">
                <v-layout class="wrap xs12 bottom-card-space">
                    <!-- Gross Amount -->
                    <v-flex md3 sm6 xs12 flex-grow-1>
                        <v-card>
                            <div class="img-div-header-box img-header-box-duration">
                                <v-icon large>attach_money</v-icon>
                            </div>
                            <div class="title-div-header-box">
                                <p class="text-uppercase">Gross Amount<p>
                                <h4 v-if="!no_data.includes(payout.gross_amount)">{{`${payout.gross_amount}`}}</h4>
                                <em v-else class="grey--text">No data</em>
                            </div>
                        </v-card>
                    </v-flex>
                    <!-- Fee Amount -->
                    <v-flex md3 sm6 xs12 flex-grow-1>
                        <v-card>
                            <div class="img-div-header-box img-header-box-distance">
                                <v-icon large>attach_money</v-icon>
                            </div>
                            <div class="title-div-header-box">
                                <p class="text-uppercase">Fee Amount<p>
                                <h4 v-if="!no_data.includes(payout.fee_amount)">{{`${payout.fee_amount}`}}</h4>
                                <em v-else class="grey--text">No data</em>
                            </div>
                        </v-card>
                    </v-flex>
                    <!-- Net Amount -->
                    <v-flex md3 sm6 xs12 flex-grow-1>
                        <v-card>
                            <div class="img-div-header-box img-header-box-renvenue">
                                <v-icon large>attach_money</v-icon>
                            </div>
                            <div class="title-div-header-box">
                                <p class="text-uppercase">Net Amount<p>
                                <h4 v-if="!no_data.includes(payout.arrival_date)">{{`${payout.net_amount}`}}</h4>
                                <em v-else class="grey--text">No data</em>
                            </div>
                        </v-card>
                    </v-flex>
                    <!-- Tip -->
                    <v-flex md3 sm6 xs12 flex-grow-1>
                        <v-card>
                            <div class="img-div-header-box img-header-box-tip">
                                <v-icon large>attach_money</v-icon>
                            </div>
                            <div class="title-div-header-box">
                                <p class="text-uppercase">Tip Amount<p>
                                <h4 v-if="!no_data.includes(payout.tip_amount)">{{`${parseFloat(payout.tip_amount).toFixed(2)}`}}</h4>
                                <em v-else class="grey--text">No data</em>
                            </div>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
            <v-layout class="wrap mt-6 mb-4">
                <v-flex>
                    <div class="title mt-2">Items</div>
                </v-flex>
                <v-spacer></v-spacer>
                <v-btn class="ma-0" text @click="downloadCSV"><v-icon class="mr-1">cloud_download</v-icon> CSV</v-btn>
            </v-layout>
        </div>
        <v-card>
            <v-data-table
                    :headers="headers"
                    :items="items"
                    :loading="loading"
                    loader-height="2"
                    hide-default-footer
                    disable-pagination
                    class="elevation-1 table-org my-sticky-last-column-table"
                    :header-props="{ 'sort-icon': 'arrow_downward' }"
                    mobile-breakpoint="100"
            >
                <template v-slot:item="{item}">
                    <tr class="items-body-row">
                        <td>{{ `$${round(parseFloat(item.amount))}` }}</td>
                        <td>{{ `$${round(parseFloat(item.fee))}` }}</td>
                        <td>{{ `$${round(parseFloat(item.net))}` }}</td>
                        <td>{{ `$${round(parseFloat(item.tip_amount))}` }}</td>
                        <td>{{ item.customer_name }}</td>
                        <td>{{ item.customer_mail }}</td>
                        <td>{{ item.invoice_no }}</td>
                        <td>
                            <v-flex style="min-width: 205px;">
                                <v-flex
                                        @click="viewClient(item.client_id)"
                                        class="pr-2 action-link"
                                >View Client <v-icon>visibility</v-icon></v-flex>
                                <v-flex
                                        @click="viewInvoice(item.invoice_id)"
                                        class="pr-2 action-link"
                                >View Invoice <v-icon>visibility</v-icon></v-flex>
                            </v-flex>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>
        <template v-if="!no_data.includes(payout_adjustments) && Array.isArray(payout_adjustments) && payout_adjustments.length > 0">
            <v-layout class="wrap mt-6 mb-4">
                <v-flex>
                    <div class="title mt-2">Аdjustments</div>
                </v-flex>
            </v-layout>
            <v-card>
                <v-data-table
                        :headers="adjustments_headers"
                        :items="payout_adjustments"
                        :loading="loading"
                        loader-height="2"
                        hide-default-footer
                        disable-pagination
                        class="elevation-1 table-org"
                        :header-props="{ 'sort-icon': 'arrow_downward' }"
                        mobile-breakpoint="100"
                >
                    <template v-slot:item="{item}">
                        <tr class="items-body-row">
                            <td>
                                <span v-if="!no_data.includes(item.amount)">{{ `$${round(parseFloat(item.amount))}` }}</span>
                                <em v-else class="grey--text">No data</em>
                            </td>
                            <td>
                                <span v-if="!no_data.includes(item.type)">{{ item.type }}</span>
                                <em v-else class="grey--text">No data</em>
                            </td>
                            <td>
                                <span v-if="!no_data.includes(item.category)">{{ item.category }}</span>
                                <em v-else class="grey--text">No data</em>
                            </td>
                            <td>
                                <span v-if="!no_data.includes(item.description)">{{ item.description }}</span>
                                <em v-else class="grey--text">No data</em>
                            </td>
                            <td>
                                <span v-if="!no_data.includes(item.datechanged)">{{ item.datechanged }}</span>
                                <em v-else class="grey--text">No data</em>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </template>
    </v-app>
</template>

<script>
    import ApiService from "@/common/api.service";
    import { preciseAdd } from "@/common/preciseMath";

    export default {
        data: () => ({
            no_data: [null, '', undefined, 'null'],
            items: [],
            payout_adjustments: [],
            payout: {},
            headers: [
                {text: 'Amount', value: 'amount', sortable: false},
                {text: 'Fee', value: 'fee', sortable: false},
                {text: 'Net', value: 'net', sortable: false},
                {text: 'Tip', value: 'tip_amount', sortable: false},
                {text: 'Customer Full Name', value: 'customer_name', sortable: false},
                {text: 'Customer Email', value: 'customer_mail', sortable: false},
                {text: 'Invoice No.', value: 'invoice_no', sortable: false},
                {text: 'Actions', sortable: false},
            ],
            adjustments_headers: [
                {text: 'Amount', value: 'amount', sortable: false},
                {text: 'Type', value: 'type', sortable: false},
                {text: 'Category', value: 'category', sortable: false},
                {text: 'Description', value: 'description', sortable: false},
                {text: 'Date Changed', value: 'datechanged', sortable: false},
            ],
            draw: 0,
            tableData: {
                draw: 0,
                length: 10,
                search: '',
                page: 0,
                column: 0,
                dir: 'desc',
            },
            loading: true,
            serverValidation: true,
            serverValidationMessage: 'Oops something went wrong...',
        }),
        mounted() {
            this.getPaymentDetails()
        },
        methods: {
            getPaymentDetails(id = this.$route.params.id) {
                ApiService.get('/payout/' + id)
                    .then(response => {
                        this.loading = false;
                        this.items = response.data.payout_items;
                        this.payout = response.data.payout
                        // if (
                        //     !this.no_data.includes(response) &&
                        //     !this.no_data.includes(response.data) &&
                        //     !this.no_data.includes(response.data.payout_adjustments) &&
                        //     Array.isArray(response.data.payout_adjustments)
                        // ) {
                        //     this.payout_adjustments = response.data.payout_adjustments
                        // } else {
                        //     this.payout_adjustments = []
                        // }
                        let adjustments_sum = 0
                        if (
                            !this.no_data.includes(this.payout_adjustments) &&
                            Array.isArray(this.payout_adjustments) &&
                            this.payout_adjustments.length > 0
                        ) {
                            adjustments_sum = this.totalSum(this.payout_adjustments, 'amount')
                        }
                        this.payout.gross_amount = this.round(this.totalSum(this.items, 'amount') + adjustments_sum)
                        this.payout.fee_amount = this.round(this.totalSum(this.items, 'fee'))
                        this.payout.net_amount = this.round(this.totalSum(this.items, 'net') + adjustments_sum)
                    })
                    .catch(error => {
                        console.log(error.response)
                        let errorMessage = error.response.status + ' ' + error.response.statusText
                        this.no_data_message = errorMessage;
                    });
            },
            downloadCSV(){
                let csvContent = ""
                let headers = '"Payout ID","Date Created","Arrival Date","Payout Amount","Amount","Fee","Net","Tip","Customer Full Name","Customer Email","Invoice No."\n'
                let csvData = []
                this.items.forEach( i => {
                    let row = {
                        id: `"${!this.no_data.includes(this.payout.id) ? this.payout.id : 'No data'}"`,
                        date: `"${!this.no_data.includes(this.payout.date) ? this.payout.date : 'No data'}"`,
                        arrival_date: `"${!this.no_data.includes(this.payout.arrival_date) ? this.payout.arrival_date : 'No data'}"`,
                        amount_payout: `"${!this.no_data.includes(this.payout.amount) ? this.round(parseFloat(this.payout.amount)) : 'No data'}"`,
                        amount: `"${!this.no_data.includes(i.amount) ? this.round(parseFloat(i.amount)) : 'No data'}"`,
                        fee: `"${!this.no_data.includes(i.fee) ? this.round(parseFloat(i.fee)) : 'No data'}"`,
                        net: `"${!this.no_data.includes(i.net) ? this.round(parseFloat(i.net)) : 'No data'}"`,
                        tip: `"${!this.no_data.includes(i.tip_amount) ? this.round(parseFloat(i.tip_amount)) : 'No data'}"`,
                        customer_name: `"${!this.no_data.includes(i.customer_name) ? i.customer_name : 'No data'}"`,
                        customer_mail: `"${!this.no_data.includes(i.customer_mail) ? i.customer_mail : 'No data'}"`,
                        invoice_no: `"${!this.no_data.includes(i.invoice_no) ? i.invoice_no : 'No data'}"`
                    };
                    csvData.push(row);
                })

                if (
                    !this.no_data.includes(this.payout_adjustments) &&
                    Array.isArray(this.payout_adjustments) &&
                    this.payout_adjustments.length > 0
                ) {
                    let adjustments_headers = '"Payout ID","Date Created","Arrival Date","Payout Amount","Adjustment Amount","Type","Category","Description","Date Changed"'
                    csvData.push({});
                    csvData.push({ header: '"Adjustments"'});
                    csvData.push({ adjustments_headers: adjustments_headers });
                    this.payout_adjustments.forEach( i => {
                        let adjustments_row = {
                            id: `"${!this.no_data.includes(this.payout.id) ? this.payout.id : 'No data'}"`,
                            date: `"${!this.no_data.includes(this.payout.date) ? this.payout.date : 'No data'}"`,
                            arrival_date: `"${!this.no_data.includes(this.payout.arrival_date) ? this.payout.arrival_date : 'No data'}"`,
                            amount_payout: `"${!this.no_data.includes(this.payout.amount) ? this.round(parseFloat(this.payout.amount)) : 'No data'}"`,
                            amount: `"${!this.no_data.includes(i.amount) ? this.round(parseFloat(i.amount)) : 'No data'}"`,
                            type: `"${!this.no_data.includes(i.type) ? i.type : 'No data'}"`,
                            category: `"${!this.no_data.includes(i.category) ? i.category : 'No data'}"`,
                            description: `"${!this.no_data.includes(i.description) ? i.description : 'No data'}"`,
                            datechanged: `"${!this.no_data.includes(i.datechanged) ? i.datechanged : 'No data'}"`
                        };
                        csvData.push(adjustments_row);
                    })
                }

                csvContent += headers
                csvContent += csvData.map(item => Object.values(item).join(",")).join("\n")
                csvContent = csvContent.replace(/(^\[)|(\]$)/gm, "");

                const data = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
                const url = URL.createObjectURL(data)
                const link = document.createElement("a");
                link.setAttribute("href", url);
                link.setAttribute("download", `Payout ${this.payout.id}.csv`);
                link.click();
            },
            titleCase(str) {
                return _.startCase(str.replace(/_/g, ' '));
            },
            viewClient(id) {
                this.$router.push('/client/' + id + '/show');
            },
            totalSum(items, key) {
                let sum = 0.0;
                items.forEach(i => {
                    let val = i[key];
                    if (!this.no_data.includes(val) && !isNaN(parseFloat(val))) {
                        sum = preciseAdd(sum, parseFloat(val))
                    }
                });
                return sum;
            },
            round (n) {
                return (Math.round((n + Number.EPSILON) * 100) / 100).toFixed(2)
            },
            viewInvoice(id) {
                this.$router.push('/invoice/' + id);
            }
        }
    }
</script>

<style>
    .header-title {
        margin-bottom: 0px !important;
    }

    .header-sub-title {
        font-size: small;
    }

    .header-p {
        text-transform: uppercase;
    }

    /*Dialog Delete*/
    .dialog-warning-custom.v-card__text {
        padding: 5px !important;
    }

    /* Footer table */
    .coupon-desc-footer {
        height: 80px !important;
        border-top: solid 1px rgba(220, 220, 220, 1.5);
    }


    .coupon-show-btn {
        float: right;
    }

    .coupon-show-btn .v-btn__content {
        color: #E03E31 !important;
    }

    .coupon-show-btn:hover, .coupon-show-btn:focus {
        background-color: #ffefec !important;
    }


    /*Layout Width*/

    .payout-details-wrap .img-div-header-box {
        width: 30%;
        display: inline-block;
        height: 70px;
        background-color: lightgray;
        vertical-align: middle;
        text-align: center;
        padding: 17px 0px;
        border-top-left-radius: inherit!important;
        border-top-right-radius: 0px!important;
        border-bottom-right-radius: 0px;
        border-bottom-left-radius: inherit;
    }

    .payout-details-wrap .img-div-header-box .v-icon {
        padding: 0px;
        color: white !important;
        border-top: none;
    }

    .payout-details-wrap .img-header-box-duration {
        background-color: #00BCD4;
    }

    .payout-details-wrap .img-header-box-distance {
        background-color: #FF9800;
    }

    .payout-details-wrap .img-header-box-renvenue {
        background-color: #4CAF50;
    }

    .payout-details-wrap .img-header-box-tip {
        background-color: #6A1B9A;
    }

    .payout-details-wrap .title-div-header-box {
        display: inline-block;
        vertical-align: middle;
        padding-left: 10px;
        width: 70%;
    }

    .payout-details-wrap .title-div-header-box p {
        font-size: 12px;
        margin: 0px;
    }

    .payout-details-wrap .title-div-header-box h4 {
        font-weight: 400;
        font-size: 19px;
    }

    .payout-details-wrap .title-div-header-box span {
        font-weight: 400;
        font-size: small;
    }

    /*Header*/
    .payout-details-wrap .bottom-card-space {
        margin-bottom: 24px;
    }

</style>







